import { Component, OnInit, Inject } from '@angular/core';
import { GeneralService } from '../services/general.service';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogConfig,
} from '@angular/material/dialog';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
import { AvtMatiereComponent } from '../avt-matiere/avt-matiere.component';
import * as globalUrls from '../services/globalVariables';
@Component({
  selector: 'app-avt-ajouter-matiere-cursus',
  templateUrl: './avt-ajouter-matiere-cursus.component.html',
  styleUrls: ['./avt-ajouter-matiere-cursus.component.scss'],
})
export class AvtAjouterMatiereCursusComponent implements OnInit {
  constructor(
    public generalService: GeneralService,
    public dialogRef: MatDialogRef<AvtAjouterMatiereCursusComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}
  matiere;
  disableBtnAjouter: boolean = false;
  exist: boolean = true;
  initMatiere;
  listeAllMatiere = [];
  listeAllSalle = [];
  ListMatiereCursus;
  listeAllMatiereIsLoadet: boolean = false;
  listeAllSalleIsLoadet: boolean = false;
  ngOnInit() {
    this.matiere = {};
    this.getInitMatiere();
    this.getListeAllMatiere();
    this.getListeSalle();
  }
  getInitMatiere() {
    this.generalService
      .rechercheTable(globalUrls.urlApplyCursusD)
      .subscribe((data) => {
        this.initMatiere = data;
        this.matiere = this.initMatiere.ApplyCursusD[0];
      });
  }
  getListeAllMatiere() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=MAT01')
      .subscribe((data) => {
        this.listeAllMatiere = [];
        data.DiverSys.forEach((matiere) => {
          if (
            this.data.listeMatiere.find((findMatiere) => {
              return findMatiere.Matiere_Code == matiere.DiverSys_Index;
            }) == undefined
          )
            this.listeAllMatiere.push(matiere);
        });
        this.listeAllMatiere = this.generalService.sort(
          this.listeAllMatiere,
          'DiverSys_Titre'
        );
        this.listeAllMatiereIsLoadet = true;
      });
  }
  getListeSalle() {
    this.listeAllSalle = this.generalService.typeSalle;
    this.listeAllSalleIsLoadet = true;
    // this.generalService.rechercheTable(this.generalService.urlParametre+"&val=SALL01").subscribe(data =>
    // {
    //   this.listeAllSalle = this.generalService.sort(data.DiverSys,"DiverSys_Titre");
    //   this.listeAllSalleIsLoadet = true;

    // });
  }
  enregistrer() {
    this.exist = false;
    this.disableBtnAjouter = true;
    this.initMatiere.ApplyCursusD[0].Cursus_Code = this.data.Cursus_Code;
    if (this.data.Cursus_Code) {
      this.generalService
        .rechercheTable(
          globalUrls.urlApplyCursusD + '&val=' + this.data.Cursus_Code
        )
        .subscribe((data) => {
          if (
            data.ApplyCursusD[0].Cursus_Code == null &&
            data.ApplyCursusD[0].Matiere_Code == null &&
            data.ApplyCursusD[0].CursusD_Id == null
          )
            data.ApplyCursusD = [];
          this.ListMatiereCursus = data;
          this.ListMatiereCursus.ApplyCursusD.push(
            this.initMatiere.ApplyCursusD[0]
          );
          this.generalService.enregisterTable(this.ListMatiereCursus).subscribe(
            (data) => {
              this.exist = true;
              this.disableBtnAjouter = false;
              this.generalService.dialogSuccess('Enregistré', true);
              this.close();
            },
            (error) => {
              this.exist = true;
              this.disableBtnAjouter = false;
              this.generalService.dialogSuccess('Non enregistré', false);
            }
          );
        });
    } else {
      this.generalService.dialogSuccess(
        'Erreur inattendue! Veuillez fermer la fenêtre et réessayer',
        false
      );
    }
  }
  ajouter(form) {
    if (form.form.valid) {
      if (this.initMatiere != undefined) {
        if (
          this.data.sommeDureeMatiere + this.matiere.CursusD_Duree <=
          this.data.Cursus_Duree
        ) {
          this.enregistrer();
        } else {
          this.generalService.dialogSuccess(
            "Vous avez dépassé le nombre d'heures total du cursus.",
            false
          );
          // var message :string = "Vous avez dépassé le nombre d’heures du cursus. Voulez-vous continuer ?";
          // var btnOk = {class:"colorGreen",icon:"keyboard_return",text:"Ok"};
          // var btnAnnuler = {class:"colorRed",icon:"close",text:"Annuler"};
          // const dialogConfig = new MatDialogConfig();
          // dialogConfig.autoFocus = true;
          // dialogConfig.data={message : message,btnOk:btnOk,btnAnnuler:btnAnnuler}
          // var dialogRef = this.generalService.dialog.open(AvtDialogDeleteComponent, dialogConfig);
          // dialogRef.afterClosed().subscribe(result =>
          // {
          //   if(result == "supprimer")
          //   {
          //     this.enregistrer()
          //   }
          //   if(result == "annuler")
          //   {
          //   }
          // });
        }
      } else
        this.generalService.dialogSuccess(
          'Veuillez patienter pendant le chargement total des données',
          false
        );
    }
  }
  close() {
    this.dialogRef.close();
  }
  openFrmAvtMatiere() {
    var matDialogConfig: MatDialogConfig = new MatDialogConfig();
    this.generalService.showBtnListeMatiere = false;
    var dialogRef = this.generalService.dialog.open(
      AvtMatiereComponent,
      matDialogConfig
    );

    dialogRef.afterClosed().subscribe(() => {
      this.generalService.showBtnListeMatiere = true;
      this.getListeAllMatiere();
    });
  }
}
